<template>
  <div class="real-name-auth">
    <el-card class="profile-card" shadow="never">
      <div slot="header" class="card-header">
        <h2>{{ $t("realNameAuth") }}</h2>
      </div>
    </el-card>

    <!-- 顶部提示 -->
    <el-alert :title="$t('authTip')" type="info" show-icon :closable="false">
      <template #description>
        <a href="https://your-official-docs-url" target="_blank">
          {{ $t("authDoc") }}
        </a>
      </template>
    </el-alert>

    <!-- 企业认证模块 -->
    <el-card v-if="enterpriseAuthInfo" class="mt-20" shadow="never">
      <div slot="header">
        <span>{{ $t("enterpriseAuth") }}</span>
        <el-tag
          :type="getStatusType(enterpriseAuthInfo.authStatus)"
          class="ml-10"
        >
          {{
            $i18n.locale === "en"
              ? enterpriseAuthInfo.authStatusTextEn
              : enterpriseAuthInfo.authStatusText
          }}
        </el-tag>
      </div>
      <el-form label-width="200px">
        <el-form-item :label="$t('enterpriseName')">
          <span>{{ enterpriseAuthInfo.enterpriseName }}</span>
        </el-form-item>
        <el-form-item :label="$t('companyType')">
          <span>{{
            $i18n.locale === "en"
              ? enterpriseAuthInfo.organizationTypeEn
              : enterpriseAuthInfo.organizationType
          }}</span>
        </el-form-item>
        <el-form-item :label="$t('creditCode')">
          <span>{{ enterpriseAuthInfo.creditCode }}</span>
        </el-form-item>
        <el-form-item :label="$t('handlerName')">
          <span>{{ enterpriseAuthInfo.handlerName }}</span>
        </el-form-item>
        <el-form-item :label="$t('handlerIdCard')">
          <span>{{ enterpriseAuthInfo.handlerIdCard }}</span>
        </el-form-item>
        <el-form-item :label="$t('applyTime')">
          <span>{{ enterpriseAuthInfo.applyTime }}</span>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="handleChangeAuth">
        {{ $t("changeEnterpriseAuth") }}
      </el-button>
    </el-card>

    <!-- 无企业认证信息时的提示 -->
    <div v-else class="no-auth-tip mt-20">
      <p>{{ $t("noAuthTip") }}</p>
      <el-button type="primary" @click="goToAuthPage">
        {{ $t("goToAuth") }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "RealNameAuth",
  data() {
    return {
      enterpriseAuthInfo: null,
      isLoading: false,
    };
  },
  mounted() {
    this.fetchAuthInfo();
  },
  methods: {
    getStatusType(status) {
      switch (String(status)) {
        case "1":
          return "warning";
        case "2":
          return "success";
        case "3":
          return "danger";
        default:
          return "default";
      }
    },
    fetchAuthInfo() {
      this.isLoading = true;
      this.$get("/get_auth_info")
        .then((res) => {
          if (res.data.code === 1 && res.data.data) {
            this.enterpriseAuthInfo = res.data.data;
          } else {
            this.enterpriseAuthInfo = null;
          }
        })
        .catch(() => {
          this.enterpriseAuthInfo = null;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleChangeAuth() {
      this.$router.push({
        path: "/about-me/merchant-auth-upload",
        query: { edit: true, id: this.enterpriseAuthInfo.id },
      });
    },
    handleShowChangeRecords() {
      this.$message.info(this.$t("changeRecord"));
    },
    goToAuthPage() {
      this.$router.push("/about-me/merchant-auth-upload");
    },
  },
};
</script>

<style scoped>
::v-deep.profile-card > .el-card__header {
  padding: 0px 16px;
}
.el-card.profile-card {
  border: none;
}

.real-name-auth {
}
.mt-20 {
  margin-top: 20px;
}
.mt-20 .ml-10 {
  margin-left: 20px;
}

.no-auth-tip {
  text-align: center;
  padding: 30px 0;
}
.no-auth-tip p {
  margin-bottom: 15px;
}
</style>
